module.exports = __webpack_public_path__ + "img/trade3.f7fbd2e3.jpg";